import React from 'react';
import { Outlet } from 'react-router-dom';
const PlainLayout = () => {

  return (
 <>
 <Outlet/>
 </>     

  );
};

export default PlainLayout;
